// src/pages/Chat/CameraCaptureModal.jsx
import React, { useState, useRef, useEffect } from "react";
import { FiX, FiCamera } from "react-icons/fi";

export default function CameraCaptureModal({ onClose, onCapture }) {
  const [error, setError] = useState(null);
  const videoRef = useRef(null);
  const streamRef = useRef(null);

  useEffect(() => {
    const startCamera = async () => {
      try {
        const s = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "user" } });
        streamRef.current = s;
        if (videoRef.current) videoRef.current.srcObject = s;
      } catch (err) {
        setError("Camera access denied or not available.");
      }
    };
    startCamera();
    return () => {
      if (streamRef.current) streamRef.current.getTracks().forEach(t => t.stop());
    };
  }, []);

  const capture = () => {
    const video = videoRef.current;
    if (!video) return;
    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0);
    canvas.toBlob((blob) => {
      onCapture(blob);
    }, "image/jpeg");
  };

  return (
    <>
      <div className="fixed inset-0 z-[110] bg-black/80 backdrop-blur-md" onClick={onClose} />
      <div className="fixed z-[111] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md">
        <div className="bg-slate-900 border border-white/10 rounded-3xl shadow-2xl overflow-hidden flex flex-col">
          <div className="flex items-center justify-between px-5 py-4">
            <span className="text-sm font-semibold text-slate-100">Camera</span>
            <button onClick={onClose} className="p-1.5 rounded-full hover:bg-white/10 text-slate-500">
              <FiX size={20} />
            </button>
          </div>

          <div className="aspect-video bg-black relative flex items-center justify-center">
            {error ? (
              <p className="text-xs text-red-400">{error}</p>
            ) : (
              <video ref={videoRef} autoPlay playsInline className="w-full h-full object-cover" />
            )}
          </div>

          <div className="p-6 flex justify-center bg-slate-900/50">
            <button
              onClick={capture}
              disabled={!!error}
              className="w-16 h-16 rounded-full bg-white border-4 border-slate-700 flex items-center justify-center text-slate-900 hover:scale-105 active:scale-95 transition-all disabled:opacity-30"
            >
              <FiCamera size={28} />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
